// Acronym loader with LLM-powered generation
// Store current acronym globally
let currentAcronym = null;
// Track current language (default is English - handle on left side)
let currentLanguage = 'en';
// Track current complexity (default is standard - handle on left side)
let currentComplexity = 'standard';

document.addEventListener('turbolinks:load', function() {
  const generateBtn = document.getElementById('generate-btn');
  const loadingContainer = document.getElementById('loading-container');
  const resultContainer = document.getElementById('result-container');
  const errorContainer = document.getElementById('error-container');
  const ariaLiveRegion = document.getElementById('aria-live-region');
  
  // Only run on acronyms page
  if (!generateBtn) return;
  
  // Track if this is the first visit (no delay needed) - reset on each page load
  let isFirstVisit = true;
  
  // Load acronym on initial page load (first load, no current acronym)
  if (loadingContainer) {
    loadAcronym(false);
  }
  
  // Add click handler for "Generate another" button
  if (generateBtn) {
    generateBtn.addEventListener('click', function(e) {
      e.preventDefault();
      isFirstVisit = false; // Mark that user has clicked
      loadAcronym(true); // Button click, send current acronym
    });
  }
  
  function loadAcronym(isButtonClick) {
    // Disable button and show loading state
    if (generateBtn) {
      generateBtn.disabled = true;
      generateBtn.textContent = currentLanguage === 'en' ? 'Please wait...' : 'Por favor espera...';
      generateBtn.setAttribute('aria-busy', 'true');
    }
    
    // Show loading, hide result and error
    if (loadingContainer) {
      loadingContainer.style.display = 'block';
      loadingContainer.setAttribute('aria-busy', 'true');
    }
    if (resultContainer) {
      resultContainer.style.display = 'none';
      resultContainer.setAttribute('aria-busy', 'false');
    }
    if (errorContainer) {
      errorContainer.style.display = 'none';
    }
    if (ariaLiveRegion) {
      ariaLiveRegion.textContent = 'Loading new acronym';
    }
    
    // Build URL with current acronym and language
    let url = '/acronyms/generate';
    const params = new URLSearchParams();
    if (isButtonClick && currentAcronym) {
      params.append('current_acronym', currentAcronym);
    }
    params.append('language', currentLanguage);
    params.append('complexity', currentComplexity);
    url += `?${params.toString()}`;
    
    // Make AJAX request to generate endpoint
    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        showError(data.error);
      } else {
        showResult(data);
      }
    })
    .catch(error => {
      console.error('Error loading acronym:', error);
      showError('Oops! The AI acronym hamster fell off its wheel. Hit the button to try again!');
    });
  }
  
  function showResult(data) {
    // Store current acronym for next request
    currentAcronym = data.acronym;
    
    // Hide loading
    if (loadingContainer) {
      loadingContainer.style.display = 'none';
      loadingContainer.setAttribute('aria-busy', 'false');
    }
    
    // Populate result container
    const acronymTitle = document.getElementById('acronym-title');
    const expandedAcronym = document.getElementById('expanded-acronym');
    const acronymDefinition = document.getElementById('acronym-definition');
    const wikipediaLink = document.getElementById('wikipedia-link');
    
    if (acronymTitle) {
      acronymTitle.textContent = data.acronym;
    }
    if (expandedAcronym) {
      expandedAcronym.textContent = data.expanded_acronym;
    }
    if (acronymDefinition) {
      acronymDefinition.textContent = data.definition;
    }
    if (wikipediaLink) {
      wikipediaLink.href = data.wikipedia_url;
      wikipediaLink.style.display = 'inline-block';
    }
    
    // Show result container
    if (resultContainer) {
      resultContainer.style.display = 'block';
      resultContainer.setAttribute('aria-busy', 'false');
    }
    
    // Update ARIA live region
    if (ariaLiveRegion) {
      ariaLiveRegion.textContent = `Acronym loaded: ${data.acronym}`;
    }
    
    // Re-enable button after 3 seconds (but immediately on first visit)
    const delay = isFirstVisit ? 0 : 3000;
    setTimeout(function() {
      if (generateBtn) {
        generateBtn.disabled = false;
        generateBtn.textContent = currentLanguage === 'en' ? 'Generate another' : 'Generar otro';
        generateBtn.setAttribute('aria-busy', 'false');
      }
    }, delay);
  }
  
  function showError(errorMessage) {
    // Hide loading
    if (loadingContainer) {
      loadingContainer.style.display = 'none';
      loadingContainer.setAttribute('aria-busy', 'false');
    }
    
    // Show error
    const errorText = document.getElementById('error-text');
    if (errorText) {
      errorText.textContent = errorMessage;
    }
    if (errorContainer) {
      errorContainer.style.display = 'block';
    }
    
    // Update ARIA live region
    if (ariaLiveRegion) {
      ariaLiveRegion.textContent = 'Error loading acronym';
    }
    
    // Re-enable button immediately on error
    if (generateBtn) {
      generateBtn.disabled = false;
      generateBtn.textContent = currentLanguage === 'en' ? 'Generate another' : 'Generar otro';
      generateBtn.setAttribute('aria-busy', 'false');
    }
  }
});

// Language picker toggle
$(document).on('turbolinks:load', function() {
  $('.slider-cradle').click(function(){
    $(this).toggleClass('is-transitioned');
    
    // Update language based on slider state
    // When is-transitioned class is present, handle is on right (Spanish visible on left)
    // When is-transitioned class is NOT present, handle is on left (English visible on left)
    const isSpanish = $(this).hasClass('is-transitioned');
    const newLanguage = isSpanish ? 'es' : 'en';
    
    // If language actually changed and we have a current acronym, request translation
    if (newLanguage !== currentLanguage && currentAcronym) {
      currentLanguage = newLanguage;
      
      // Disable button and show loading state
      const generateBtn = document.getElementById('generate-btn');
      if (generateBtn) {
        generateBtn.disabled = true;
        generateBtn.textContent = currentLanguage === 'en' ? 'Please wait...' : 'Por favor espera...';
        generateBtn.setAttribute('aria-busy', 'true');
      }
      
      // Request the same acronym in the new language
      const loadingContainer = document.getElementById('loading-container');
      const resultContainer = document.getElementById('result-container');
      const errorContainer = document.getElementById('error-container');
      const ariaLiveRegion = document.getElementById('aria-live-region');
      
      if (loadingContainer) {
        loadingContainer.style.display = 'block';
        loadingContainer.setAttribute('aria-busy', 'true');
      }
      if (resultContainer) {
        resultContainer.style.display = 'none';
        resultContainer.setAttribute('aria-busy', 'false');
      }
      if (errorContainer) {
        errorContainer.style.display = 'none';
      }
      if (ariaLiveRegion) {
        ariaLiveRegion.textContent = 'Translating acronym';
      }
      
      // Build URL with translate flag
      let url = '/acronyms/generate';
      const params = new URLSearchParams();
      params.append('translate_acronym', currentAcronym);
      params.append('language', currentLanguage);
      params.append('complexity', currentComplexity);
      url += `?${params.toString()}`;
      
      // Make AJAX request
      fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          showError(data.error);
        } else {
          showResult(data);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        showError('Failed to load acronym. Please try again.');
      });
    } else {
      currentLanguage = newLanguage;
    }
    
    // Update button text immediately if not loading
    const generateBtn = document.getElementById('generate-btn');
    if (generateBtn && !generateBtn.disabled) {
      generateBtn.textContent = currentLanguage === 'en' ? 'Generate another' : 'Generar otro';
    }
  });
  
  // Helper functions for language toggle
  function showResult(data) {
    currentAcronym = data.acronym;
    
    const loadingContainer = document.getElementById('loading-container');
    const resultContainer = document.getElementById('result-container');
    const ariaLiveRegion = document.getElementById('aria-live-region');
    
    if (loadingContainer) {
      loadingContainer.style.display = 'none';
      loadingContainer.setAttribute('aria-busy', 'false');
    }
    
    const acronymTitle = document.getElementById('acronym-title');
    const expandedAcronym = document.getElementById('expanded-acronym');
    const acronymDefinition = document.getElementById('acronym-definition');
    const wikipediaLink = document.getElementById('wikipedia-link');
    
    if (acronymTitle) {
      acronymTitle.textContent = data.acronym;
    }
    if (expandedAcronym) {
      expandedAcronym.textContent = data.expanded_acronym;
    }
    if (acronymDefinition) {
      acronymDefinition.textContent = data.definition;
    }
    if (wikipediaLink) {
      wikipediaLink.href = data.wikipedia_url;
      wikipediaLink.style.display = 'inline-block';
    }
    
    if (resultContainer) {
      resultContainer.style.display = 'block';
      resultContainer.setAttribute('aria-busy', 'false');
    }
    
    if (ariaLiveRegion) {
      ariaLiveRegion.textContent = `Acronym loaded: ${data.acronym}`;
    }
    
    // Re-enable button after 3 seconds to match generate button behavior
    const generateBtn = document.getElementById('generate-btn');
    setTimeout(function() {
      if (generateBtn) {
        generateBtn.disabled = false;
        generateBtn.textContent = currentLanguage === 'en' ? 'Generate another' : 'Generar otro';
        generateBtn.setAttribute('aria-busy', 'false');
      }
    }, 3000);
  }
  
  function showError(errorMessage) {
    const loadingContainer = document.getElementById('loading-container');
    const errorContainer = document.getElementById('error-container');
    const ariaLiveRegion = document.getElementById('aria-live-region');
    
    if (loadingContainer) {
      loadingContainer.style.display = 'none';
      loadingContainer.setAttribute('aria-busy', 'false');
    }
    
    const errorText = document.getElementById('error-text');
    if (errorText) {
      errorText.textContent = errorMessage;
    }
    if (errorContainer) {
      errorContainer.style.display = 'block';
    }
    
    if (ariaLiveRegion) {
      ariaLiveRegion.textContent = 'Error loading acronym';
    }
    
    const generateBtn = document.getElementById('generate-btn');
    if (generateBtn) {
      generateBtn.disabled = false;
      generateBtn.textContent = currentLanguage === 'en' ? 'Generate another' : 'Generar otro';
      generateBtn.setAttribute('aria-busy', 'false');
    }
  }
  
  // Complexity picker toggle
  $('.complexity-slider-cradle').click(function(){
    $(this).toggleClass('is-transitioned');
    
    // Update complexity based on slider state
    // When is-transitioned class is NOT present, handle is on left (Standard)
    // When is-transitioned class is present, handle is on right (Advanced)
    const isAdvanced = $(this).hasClass('is-transitioned');
    currentComplexity = isAdvanced ? 'advanced' : 'standard';
  });
});
